export const SET_SIMPLE_EMAIL_ENTRADA_BORDERO_ACTION = '@emailEntradaBordero/SET_SIMPLE_EMAIL_ENTRADA_BORDERO_ACTION';
export const SET_BUSCAR_DADOS_TABELA = '@emailEntradaBordero/SET_BUSCAR_DADOS_TABELA';
export const SET_COMMON_ACTION = '@emailEntradaBordero/SET_COMMON_ACTION';
export const ENVIAR_EMAIL_ENTRADA_BORDERO_ACTION = '@emailEntradaBordero/ENVIAR_EMAIL_ENTRADA_BORDERO_ACTION';
export const EXCLUIR_EMAIL_ENTRADA_BORDERO_ACTION = '@emailEntradaBordero/EXCLUIR_EMAIL_ENTRADA_BORDERO_ACTION';
